<template>
  <table class="w-full text-start">
    <tr class="row" v-if="!hideHeader">
      <th v-for="field in fields" :key="field.key" :class="{ 'col-grow': field.grow }">
        {{ field.label }}
      </th>
    </tr>
    <tr class="row" v-for="(dataRow, rowIndex) in data" :key="rowIndex">
      <template v-for="field in fields" :key="field.key">
        <slot :name="field.key" v-bind="dataRow">
          <td :class="{ 'col-grow': field.grow }">{{ dataRow[field.key] }}</td>
        </slot>
      </template>
    </tr>
  </table>
</template>

<script setup lang="ts">
import { PropType } from "vue";

const props = defineProps({
  hideHeader: { type: Boolean, default: false },
  fields: {
    type: Array as PropType<
      Array<{
        key: string;
        label: string;
        grow?: boolean;
      }>
    >,
    required: false,
  },
  data: {
    type: Array as PropType<Array<{ [key: string]: any }>>,
    required: true,
  },
});
</script>

<style lang="postcss" scoped>
.row {
  border-bottom: 0.5px solid black;
  @apply h-10 border-b-secondary;

  th,
  td {
    @apply text-start;
    min-width: 80px;
  }

  th {
    @apply text-gray-500;
  }
}

.col-grow {
  @apply flex-grow w-full text-start;
}
</style>
